<template>
  <div>
    <p v-if="type === 'NO_PLUS_USER'">
      BMW Plus 미등록 사용자 입니다.<br>
      Plus 가입 후 사용해주세요.
    </p>
    <p v-else-if="type === 'NO_PLUS_VEHICLES'">
      BMW Plus에 등록된 차량이 없습니다.<br>
      BMW Plus내 차량등록이 완료된 차량에 한해서 서비스 가입이 가능합니다.
    </p>
    <p v-if="type === 'NO_VTG_USER'">
      BMW Vantage 미등록 사용자 입니다.<br>
      Vantage 가입 후 사용해주세요.
    </p>
    <p v-else-if="type === 'NO_VTG_VEHICLES'">
      BMW Vantage에 등록된 차량이 없습니다.<br>
      BMW Vantage내 차량등록이 완료된 차량에 한해서 서비스 가입이 가능합니다.
    </p>
    <p v-else-if="type === 'NO_ABLE_SUBSC_VEHICLE'">
      서비스 가입 가능한 차량이 없습니다.<br>
      <!-- 기존 서비스 진행중인 차량의 연장신청은 My BMW ServiceCare+에서 진행해주세요. -->
    </p>
    <p v-else-if="type === 'PKGS_ENABLE'">
      해당 연차는 가입이 불가능합니다.<br>
      가입 가능한 차량 연차는 다음과 같습니다.
      <slot></slot>
    </p>
    <p v-else-if="type === 'NEED_SUBSC_TERM_CHECK'">
      필수약관 동의후 서비스 가입 절차 진행이 가능합니다.
    </p>
    <p v-else-if="type === 'NEED_SUBSC_TERM_RECEIVE_CHECK'">
      {{ ConstTerms.getTermsTitle()[ConstTerms.AD_RECEIVE_AGREE] }}를 선택하셨습니다.<br>
      수신방법을 선택해 주세요.
    </p>
    <p v-else-if="type === 'SUBSC_OVERLAP'">
      이미 서비스 진행중인 차량입니다.<br>
      <!-- 연장 신청을 원하실 경우 My BMW ServiceCare+에서 연장신청을 진행해주세요.<br><br> -->
    </p>

    <div v-else-if="type === 'SUBSC_INFO'" style="text-align:left;">
      <div>
        <div style="word-break: break-all">
        {{$store.state.insuranceName}} 가입을 희망하는 고객님께서는 아래 사항을 준비 후 차량 내에서 신청해 주세요.
        </div>
      </div>

      <div style="margin-top:20px;font-weight: bold">
        <p class="textType1">자동차등록증</p>
        <p class="textType1">자동차정기검사결과표</p>
        <p class="textType1">차량 계기판 사진</p>
      </div>

      <div style="margin-top:20px">
          <p class="textType2" style="margin-top:10px">{{$store.state.insuranceName}}은 주행거리가 18만 km 내에서만 가입 가능합니다.</p>
          <p class="textType2"><span class="WBkeepAll" v-html="$store.state.insuranceApplyNoti"></span></p>
          <p class="textType2">기타 자세한 사항은 제휴 보험사 약관에 따릅니다.</p>
      </div>
    </div>

    <div v-else-if="type === 'SUBSC_INSURANCE_NOTI'">
      {{this.$store.state.insuranceName}}을 선택하신 고객님께 안내말씀드립니다.
      <br><br>
      <span class="WBkeepAll" v-html="$store.state.insuranceApplyNoti"></span>
      <br>
      <div style="font-size:13px;">({{this.$store.state.insuranceName}} 신청자에 한합니다.)</div>
    </div>

    <p v-else-if="type === 'MATCH_USER_VEHICLE_WARNING'">
      입력하신 차대번호로 조회되는 차량과 고객님의 정보가 일치 하지 않습니다.<br>
      BMW 차대번호가 아닐 수 있으니 다시 한번 확인해 주세요.<br>
      <br>
      계속해서 조회가 안될 경우 고객센터로 문의주세요. (080-269-2200)
    </p>
    <p v-else-if="type === 'NON_INCLUDE_VEHICLE_PKG'">
      해당 모델로 서비스 가입이 가능한 멤버십이 존재하지 않습니다.
    </p>
    <p v-else-if="type === 'NON_MATCH_VEHICLE_PKG'">
      해당 모델로 서비스 가입이 불가능한 멤버십 입니다.
    </p>
    <p v-else-if="type === 'DONE_USER_VEHICLE_CHECK'">
      ⁠차량 고객인증이 완료되었습니다.<br>
      다음 절차 페이지로 이동합니다.
    </p>
    <div v-else-if="type === 'INSP_PANEL_NORMAL_WARNING'">
      <p>
        선택하신 차량 모델 정보가 실제 차량의 정보와 다를 시, 서비스 철회 또는 서비스 이용에 제한 및 불이익이 있을 수 있습니다.
        모든 정보가 정상적으로 입력되어 있는지 결제 전 다시 한번 확인해주세요.
      </p>
      <div class="mgt rdChk" >
        <input type="checkbox" id="confirm" v-model="checkValue" @change="$emit('action', checkValue)">
        <label for="confirm"><span>주의사항을 읽고 확인하였습니다.</span></label>
      </div><br>
    </div>
    <div v-else-if="type === 'INSP_PANEL_PHOTO_WARNING'">
      <p>
        제출하신 자동차 정기 검사표 및 차량 계기판이 실제 차량의 정보와 다를 시, 서비스 철회 또는 서비스 이용에 제한 및 불이익이 있을 수 있습니다.
        모든 정보가 정상적으로 입력되어 있는지 결제 전 다시 한번 확인해주세요.
      </p>
      <div class="mgt rdChk" >
        <input type="checkbox" id="confirm" v-model="checkValue" @change="$emit('action', checkValue)">
        <label for="confirm"><span>주의사항을 읽고 확인하였습니다.</span></label>
      </div><br>
    </div>
    <p v-else-if="type === 'NEED_INPUT_KM'">
      차량 주행거리를 입력해주세요.
    </p>
    <p v-else-if="type === 'KM_LIMIT_WARNING'">
      {{$store.state.insuranceName}}을 포함한 서비스의 경우 총 주행거리가 18만Km가 넘으면 서비스 가입이 불가합니다.
    </p>
    <p v-else-if="type === 'UNDEFINED_PROMO_SLUG'">
      사용할 수 없는 쿠폰코드 입니다.
    </p>
    <p v-else-if="type === 'CHECK_INPUT_DATA'">
      입력 정보를 확인해주세요.
    </p>
    <div v-else-if="type === 'SUBSC_REVOKE_CANCEL'">
      <p>서비스 해지신청을 취소하시겠습니까?</p>
      <div class="mgt2">
        <a class="btnS w100 bGray mgb" @click="$emit('action')">네, 서비스 해지신청을 취소합니다.</a><br>
        <a class="btnS w100 bGray" @click="$emit('close')">아니오, 취소하지 않습니다.</a>
      </div>
    </div>
    <p v-else-if="type === 'SUBSC_REVOKE_CANCEL_COMPLETE'">
      구독 해지신청 취소가 완료되었습니다.
    </p>
    <p v-else-if="type === 'SUBSC_EXTEND_WARNING'">
      구독 연장신청은 APP에서만 진행 가능합니다.<br>
      <a v-if="$store.state.isDev" class="mgt1 btnS" @click="$emit('action')">Dev 연장신청 진행</a>
    </p>
    <p v-else-if="type === 'PKG_INSURANCE_APPLY_SERVEY_FALSE'">
      해당 연차는 가입이 불가능합니다.<br>
      가입 가능한 차량 연차는 다음과 같습니다.
      <br>
      <br>
      <span style="display: block;width: 100%;text-align: left">
        <span><strong>- Standared / Premium</strong> : 가입 제한 없음</span><br>
        <span><strong>- Standared + Power Train Warranty</strong> : 60개월 초과 ~ 96개월 이하</span><br>
        <span><strong>- Premium + Power Train Warranty</strong> : 60개월 초과 ~ 96개월 이하</span><br>
      </span>
    </p>
    <p v-else-if="type === 'SUBSC_REQ_DEALER'">
      구매하실 상품의 판매자를 선택해 주세요.
    </p>

    <p v-else-if="type === 'SUBSC_REQ_ADVISOR'">
      추천인을 선택해 주세요.
    </p>

    <p v-else-if="type === 'SUBSC_ECALATION_SUCCESS'">
      양수 신청이 완료되었습니다.
    </p>

    <p v-else-if="type === 'SUBSC_REQ_VEHICLE'">
      차량을 선택해주세요.
    </p>


    <p v-else-if="type === 'SUBSC_REQ_REG_DATE'">
      차량 최초 등록일을 선택해주세요.
    </p>

    <p v-else-if="type === 'SUBSC_REQ_DEALER_NOT_CO_CARD'">
      선택하신 딜러사는 법인카드 결제를 사용하실 수 없습니다.
    </p>

    <p v-else>{{type}}</p>
  </div>
</template>


<script>

import ConstTerms from "../../helpers/ConstTerms";

export default {
  data () {
    return {
      ConstTerms,
      checkValue: false,
    }
  },

  props: {
    type: String,
  },

  computed: {
  },

}
</script>

<style scoped>
.smallText {

}
.textType1 {
  margin-top: 0;
  padding-left: 10px;
  position: relative;
  line-height: 1.4;
  margin-bottom: 3px;
  word-break: keep-all;
  color: #0068dc;
}
.textType1 span {
}

.textType1::after {
  content: "-";
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  height: 0;
}
.textType2 {
  margin-top: 0;
  padding-left: 10px;
  position: relative;
  line-height: 1.4;
  margin-bottom: 3px;
  word-break: keep-all;
  word-wrap: break-word;
  color: #898989;
}
.textType2::after {
  content: "-";
  display: block;
  position: absolute;
  top: 3px;
  left: 0;
  height: 0;
}
</style>
